import React, { useState, useRef, useEffect } from 'react';

function normalizeOptions(column, externalOptions) {
  if (externalOptions) return externalOptions;
  const raw = column.options || [];
  if (!Array.isArray(raw)) return [];
  return raw.map(o => {
    if (typeof o === 'string') return { label: o, value: o };
    if (o && typeof o === 'object') return { label: o.label || o.value || String(o), value: o.value || o.label || String(o) };
    return { label: String(o), value: String(o) };
  });
}

export default function SelectEditor({ value, column, onSave, onCancel, options: externalOptions }) {
  const [val, setVal] = useState(value || '');
  const selectRef = useRef(null);

  useEffect(() => { selectRef.current?.focus(); }, []);

  const opts = normalizeOptions(column, externalOptions);

  return (
    <>
      <select
        ref={selectRef}
        value={val}
        onChange={e => setVal(e.target.value)}
      >
        <option value="">-- Seleccionar --</option>
        {opts.map((opt, i) => (
          <option key={i} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <button className="cm-cell-edit-btn cm-cell-edit-btn--save" onClick={() => onSave(val, [])}>
        <i className="fas fa-check" />
      </button>
      <button className="cm-cell-edit-btn cm-cell-edit-btn--cancel" onClick={onCancel}>
        <i className="fas fa-times" />
      </button>
    </>
  );
}
